export enum Priorities {
  High = 'high',
  Medium = 'medium',
  Normal = 'normal'
}

export const types_Priorities = [
  { key: Priorities.High, name: 'RIDICATA' },
  { key: Priorities.Medium, name: 'MEDIE' },
  { key: Priorities.Normal, name: 'NORMALA' }
];

export type IEditField = {
  label: string;
  key: string;
  originalValue: string;
};

export enum TermPeriods {
  Hours = 'hours',
  Days = 'days',
  Weeks = 'weeks',
  Months = 'months',
  Years = 'years'
}

export const types_TermPeriods = [
  { key: TermPeriods.Days, name: 'Zile' },
  { key: TermPeriods.Weeks, name: 'Saptamani' },
  { key: TermPeriods.Months, name: 'Luni' },
  { key: TermPeriods.Years, name: 'Ani' }
];
